<template>
        <div class="toast show" role="alert" aria-live="assertive" aria-atomic="true">
            <div class="toast-body py-2">
                <fa-icon :icon="queue.icon ? queue.icon : ['fal', 'crosshairs']"></fa-icon>
                <span class="d-none d-sm-inline ml-2">{{ queue.message }}</span>
            </div>
            <div class="progress" style="height: 4px;">
                <div class="progress-bar bg-info" :class="width >= 100 ? 'progress-bar-striped progress-bar-animated' : ''" role="progressbar" :style="'width: ' + width + '%'" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'APIQueue',
  props: ['queue'],
  data () {
    return {
      width: 0
    }
  },
  computed: {
    ...mapState({
      axiosTiming: state => state.axiosTiming
    }),
    avgTime () {
      if (this.axiosTiming[this.queue.url]) {
        let time = 0
        this.axiosTiming[this.queue.url].forEach(value => {
          time += value
        })
        return time / this.axiosTiming[this.queue.url].length
      } else return 10
    }
  },
  created () {
    const interval = 100
    const increment = 100 / (this.avgTime * 1000 / interval)
    const timer = setInterval(() => {
      this.width += increment
      if (this.width >= 100) clearInterval(timer)
    }, interval)
  }
}
</script>

<style lang="scss">

</style>
